import * as React from "react";
import { SVGProps } from "react";
export const InboxIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.5 17C4.09733 17 3.74667 16.8507 3.448 16.552C3.14933 16.2533 3 15.9027 3 15.5V4.5C3 4.08333 3.14933 3.72933 3.448 3.438C3.74667 3.146 4.09733 3 4.5 3H15.5C15.9167 3 16.2707 3.146 16.562 3.438C16.854 3.72933 17 4.08333 17 4.5V15.5C17 15.9027 16.854 16.2533 16.562 16.552C16.2707 16.8507 15.9167 17 15.5 17H4.5ZM4.5 15.5H15.5V12.5H13.167C12.8477 13.0973 12.4067 13.58 11.844 13.948C11.2813 14.316 10.6667 14.5 10 14.5C9.31933 14.5 8.69767 14.3193 8.135 13.958C7.573 13.5973 7.139 13.1113 6.833 12.5H4.5V15.5ZM10 13C10.4447 13 10.8267 12.8473 11.146 12.542C11.4653 12.236 11.7013 11.868 11.854 11.438C11.91 11.2847 12.0073 11.1733 12.146 11.104C12.2847 11.0347 12.4373 11 12.604 11H15.5V4.5H4.5V11H7.396C7.56267 11 7.71533 11.0347 7.854 11.104C7.99267 11.1733 8.09 11.2847 8.146 11.438C8.29867 11.868 8.53467 12.236 8.854 12.542C9.17333 12.8473 9.55533 13 10 13Z"
            fill="currentColor"
        />
    </svg>
);
InboxIcon.displayName = "InboxIcon";
